import React, { useRef, useState, useEffect, useContext } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";
import { AuthContext } from "../../context/AuthContext";

function Room() {
  const {
    loginUser,
    getDoctorDetails,
    doctorDetails,
    doctorDetailsLoading,
    doctorDetailsError,
  } = useContext(AuthContext);

  const { roomId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const zpRef = useRef(null);
  const videoContainerRef = useRef(null);
  const [joined, setJoined] = useState(false);
  const [callType, setCallType] = useState(""); // State to store the call type

  useEffect(() => {
    if (doctorDetails === null && loginUser?.id) {
      getDoctorDetails(loginUser.id);
    }
    console.log("Doctor Details:", doctorDetails);
  }, [getDoctorDetails, doctorDetails, loginUser]);

  useEffect(() => {
    if (doctorDetails === null && loginUser?.id) {
      getDoctorDetails(loginUser.id);
    }
    console.log("Doctor Details:", doctorDetails);
  }, [getDoctorDetails, doctorDetails, loginUser]);

  // Initialize ZegoUIKit and join room on component mount
  const myMeeting = (type) => {
    const appID = 991124298;
    const serverSecret = "0ec489e90c8db3536bf69cb95a38859b";
    const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(
      appID,
      serverSecret,
      roomId,
      Date.now().toString(),
      loginUser.email || "Guest"
    );
    const zp = ZegoUIKitPrebuilt.create(kitToken);
    zpRef.current = zp;
    zp.joinRoom({
      container: videoContainerRef.current,
      sharedLinks: [
        {
          name: "Video Call Link",
          url:
            window.location.protocol +
            "//" +
            window.location.host +
            window.location.pathname +
            "?type=" +
            encodeURIComponent(type),
        },
      ],
      scenario: {
        mode:
          type === "one-on-one"
            ? ZegoUIKitPrebuilt.OneONoneCall
            : ZegoUIKitPrebuilt.GroupCall,
      },
      maxUsers: type === "one-on-one" ? 2 : 10,
      onJoinRoom: () => {
        setJoined(true);
      },
      onLeaveRoom: () => {
        navigate("/");
      },
    });
  };

  // Handle exit from the room
  const handleExit = () => {
    if (zpRef.current) {
      zpRef.current.destroy();
    }
    navigate("/");
  };

  // On component mount, extract call type from location and initialize meeting
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const type = query.get("type");
    setCallType(type); // Update state with call type
  }, [location.search]);

  // Initialize meeting after callType state is set
  useEffect(() => {
    if (callType) {
      myMeeting(callType);
    }
    // Cleanup function for component unmount
    return () => {
      if (zpRef.current) {
        zpRef.current.destroy();
      }
    };
  }, [callType, roomId, navigate]);

  return (
    <div className="flex flex-col h-screen">
      {!joined && (
        <>
          <header className="bg-gray-800 text-white p-4 text-center text-2xl">
            {callType === "one-on-one"
              ? "One-on-One Video Call"
              : "Group Video Call"}
          </header>
          <button
            className="absolute top-4 right-4 px-4 py-2 bg-red-600 text-white border-none rounded cursor-pointer hover:bg-red-700 transition-colors duration-200"
            onClick={handleExit}
          >
            Exit
          </button>
        </>
      )}
      <div
        ref={videoContainerRef}
        className="flex-1 flex justify-center items-center"
        style={{ height: "calc(100vh - 3rem)" }}
      />
    </div>
  );
}

export default Room;
